import { DnrInfo } from "../model/Prices";

export type Weight = {
	value: number;
	unitOfMeasurement: string;
};
export type Money = {
	amount: number;
	currency: string;
};
export type MoneyWrapper = {
	amount: Money | null | undefined;
	strikeThrough: Money | null | undefined;
	info: string | null | undefined;
};
export type BettyId = string;
export type Country = string;
export type Locale = string;
export type StoreId = string;
export type UserId = string;
export type ShoppingCartId = string;
export type ShoppingCartVersion = number;
export type CardholderNumber = string;
export type AddressId = string;
export type Callback<T> = (param: T) => void;
export type Dictionary<T> = Record<string, T | null | undefined>;
export type ServiceErrorCode = string;
export class ServiceError extends Error {
	code: ServiceErrorCode;
	value?: string | null;
	type?: string;
	source?: string;
	i18nKey?: string;
	constructor(errorData: Omit<ServiceError, "name">) {
		super(errorData.message);
		this.name = this.constructor.name;
		this.code = errorData.code;
		this.value = errorData.value;
		this.type = errorData.type;
		this.source = errorData.source;
		this.i18nKey = errorData.i18nKey;
	}
}
export type PriceConfiguration = {
	priceCompact: {
		primary: string;
		secondary: string;
	};
	priceBreakdown: {
		primaryPriceType: string;
		includeMarginTaxesInPrice: boolean;
	};
};
export type PriceConfigured = ValidPriceConfigured | InvalidPriceConfigured;
export type InvalidPriceConfigured = {
	valid: false;
};
export type ValidPriceConfigured = {
	valid: true;
	currency: string | null | undefined;
	employeePriceIsGross: boolean;
	unitPrices: UnitPrices;
	positionPrices: PositionPrices;
	savings: {
		absolute: Money | null | undefined;
		percent: number | null | undefined;
	};
	summaryDnr: DnrInfo | null | undefined;
};
export type UnitPrices = {
	primary: MoneyWrapper;
	secondary: MoneyWrapper | null | undefined;
	empties: MoneyWrapper;
};
export type PositionPrices = {
	primary: MoneyWrapper;
	secondary: MoneyWrapper | null | undefined;
};
export type SelectOption = {
	value: string;
	label: string;
	disabled?: boolean;
	hidden?: boolean;
	className?: string;
	key?: string;
};
